// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Moment from "moment";
import * as ReactDates from "react-dates";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";
import * as JsxRuntime from "react/jsx-runtime";

let make = React.memo(props => {
  let isDayBlocked = props.isDayBlocked;
  let onChange = props.onChange;
  let value = props.value;
  let date = Stdlib_Nullable.fromOption(Stdlib_Option.map(value, prim => Moment(prim)));
  let onDateChange = React.useCallback(date => onChange(date.toDate()), [value]);
  let isDayBlocked$1 = React.useCallback(day => Stdlib_Option.mapOr(isDayBlocked, false, fn => fn(day.toDate())), [value]);
  return JsxRuntime.jsx(ReactDates.DayPickerSingleDateController, {
    date: date,
    onDateChange: onDateChange,
    isDayBlocked: isDayBlocked$1,
    transitionDuration: 0,
    noBorder: true,
    focused: true
  });
});

export {
  make,
}
/* make Not a pure module */
